import { performance, requestAnimationFrame, Image } from 'global';
import Component from './component';

export default class CrossfadeImage extends Component {
  getDefaultProps () {
    return {
      width: '100%',
      height: '100%',
      duration: 300,
      src: '',
      fallbackSrc: ''
    };
  }

  setProp (name, newValue, update = true) {
    const oldValue = this.props[name];
    if (oldValue !== newValue) {
      this.props[name] = newValue;
      this.attributeChangedCallback(name, oldValue, newValue);
    }
  }

  render () {
    return `<div class="iono-crossfade-image">
      <img src="${this.props.src}" width="${this.props.width}" height="${this.props.height}" />
    </div>`;
  }

  update (changed = []) {}

  attach (element) {
    super.attach(element);

    this.$image = this.$('img');
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (!this.isAttached()) return;

    switch (name) {
      case 'src':
        this.crossfade(oldValue, newValue);
        break;
      case 'width':
        this.$image.setAttribute('width', this.props.width);
        break;
      case 'height':
        this.$image.setAttribute('height', this.props.height);
        break;
    }
  }

  async fadeIn () {
    return new Promise(resolve => {
      const start = performance.now();

      const step = now => {
        const delta = Math.min((now - start) / this.props.duration, 1);

        this.$image.style.opacity = delta * 1;

        if (delta < 1) {
          requestAnimationFrame(step);
        } else {
          resolve();
        }
      };

      step(start);
    });
  }

  async fadeOut () {
    return new Promise(resolve => {
      const start = performance.now();

      const step = now => {
        const delta = Math.min((now - start) / this.props.duration, 1);

        this.$image.style.opacity = 1 - delta * 1;

        if (delta < 1) {
          requestAnimationFrame(step);
        } else {
          resolve();
        }
      };

      step(start);
    });
  }

  async preload (src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = resolve;
      img.onerror = reject;
      img.src = src;
    });
  }

  async crossfade (oldSrc, newSrc) {
    // no new image so fade out current
    if (!newSrc) {
      this.$element.style.backgroundImage = '';
      await this.fadeOut();
      this.$image.src = '';
      return;
    }

    const oldSrcWasLoaded = this.$image.src === oldSrc;

    try {
      await this.preload(newSrc);

      if (oldSrc) {
        // change background image
        this.$element.style.backgroundImage = `url(${oldSrc})`;
      }

      // update image source
      this.$image.src = newSrc;

      // fade in new image
      await this.fadeIn();
    } catch (e) {
      if (this.props.fallbackSrc && newSrc !== this.props.fallbackSrc) {
        return await this.crossfade(oldSrc, this.props.fallbackSrc);
      }

      if (oldSrcWasLoaded) {
        this.$element.style.backgroundImage = '';
        await this.fadeOut();
        this.$image.src = '';
      }
    }
  }
}
